import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.2426 1.39354L1.39336 16.2428C1.00283 16.6333 1.00283 17.2665 1.39336 17.657L6.3431 22.6067C6.73363 22.9973 7.36679 22.9973 7.75732 22.6067L22.6066 7.7575C22.9971 7.36698 22.9971 6.73381 22.6066 6.34329L17.6568 1.39354C17.2663 1.00302 16.6331 1.00302 16.2426 1.39354ZM7.05021 20.4854L3.51468 16.9499L5.63599 14.8286L6.34309 15.5357C6.73362 15.9262 7.36678 15.9262 7.75731 15.5357C8.14783 15.1452 8.14783 14.512 7.75731 14.1215L7.0502 13.4144L9.87865 10.5859L10.5858 11.293C10.9763 11.6836 11.6095 11.6836 12 11.293C12.3905 10.9025 12.3905 10.2694 12 9.87883L11.2929 9.17171L14.1213 6.34324L14.8284 7.05037C15.219 7.44089 15.8521 7.44089 16.2427 7.05037C16.6332 6.65984 16.6332 6.02668 16.2427 5.63615L15.5355 4.92903L16.9497 3.51486L20.4852 7.05039L7.05021 20.4854Z"
  }));
});
var DescriptiveRuler = AbstractIcon.withComponent(Icon);
DescriptiveRuler.displayName = 'DescriptiveRuler';
export default DescriptiveRuler;